// extracted by mini-css-extract-plugin
export default {"title":"event-detail_title__z5pQY"};